import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

const serviceLinks = [
  { label: 'Recurring Home Cleaning', href: '/services/recurring-cleaning' },
  { label: 'Deep Cleaning', href: '/services/deep-cleaning' },
  { label: 'Move-In / Move-Out Cleaning', href: '/services/move-in-out-cleaning' },
];

const linkCls = 'text-sm text-foreground-900 hover:text-secondary-500 whitespace-nowrap cursor-pointer';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300 px-4 md:px-6 lg:px-20 pt-16 md:pt-20 pb-8">
      <div className="max-w-content mx-auto">
        <div className="flex flex-col md:flex-row md:justify-between gap-10">
          <div className="max-w-sm">
            <Link to="/" className="font-heading text-xl font-semibold tracking-[0.18em] cursor-pointer">CLEARY</Link>
            <p className="mt-4 text-[15px] leading-[1.6] text-foreground-600">Thoughtful residential cleaning, delivered with care and attention to every detail.</p>
          </div>
          <div className="flex flex-wrap gap-12 md:gap-16 lg:gap-20">
            <nav aria-label="Footer">
              <p className="text-xs font-medium tracking-[0.14em] text-secondary-500 mb-4">EXPLORE</p>
              <ul className="space-y-3">
                {navLinks.map((l) => <li key={l.href}><Link to={l.href} className={linkCls}>{l.label}</Link></li>)}
              </ul>
            </nav>
            <div>
              <p className="text-xs font-medium tracking-[0.14em] text-secondary-500 mb-4">SERVICES</p>
              <ul className="space-y-3">
                {serviceLinks.map((l) => <li key={l.href}><Link to={l.href} className={linkCls}>{l.label}</Link></li>)}
              </ul>
            </div>
            <div>
              <p className="text-xs font-medium tracking-[0.14em] text-secondary-500 mb-4">GET STARTED</p>
              <ul className="space-y-3">
                <li><Link to="/contact" className={linkCls}>Request a Quote</Link></li>
                <li><Link to="/services" className={linkCls}>Our Services</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-6 border-t border-background-300 flex flex-col sm:flex-row justify-between gap-3 text-xs text-foreground-600">
          <p>© 2026 CLEARY. All rights reserved.</p>
          <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="self-start hover:text-secondary-500 whitespace-nowrap cursor-pointer">Back to top <i className="ri-arrow-up-line" /></button>
        </div>
      </div>
    </footer>
  );
}